import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Grid } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';
import { SchemaEntityTypeId } from 'services/schemas/types';

// Global Components
// @ts-ignore
import EntityOptions from 'components/EntityOptions';

// Global Selectors
import { selectSpraySchemaInnerEntityTypeId } from 'services/schemas/selectors';
import { EntityId } from 'services/entities/types';
import SpraySchemaInnerEntityTableFieldWarning from './components/SpraySchemaInnerEntityTableFieldWarning';
import SpraySchemaInnerEntityTableFieldRender from './components/SpraySchemaInnerEntityTableFieldRender';
import { EntityDropdownOptions } from './types';
import SpraySchemaInnerEntityOptions from './components/SpraySchemaInnerEntityOptions';
import { InnerEntityOptions } from './components/SpraySchemaInnerEntityOptions/types';

interface OwnProps {
    name: string;
    validate?: any;
    entityId?: EntityId;
}

interface ConnectedProps {
    spraySchemaEntityTypeId?: SchemaEntityTypeId;
}

type Props = OwnProps & ConnectedProps;

export class SpraySchemaInnerEntityTableField extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { name, validate, spraySchemaEntityTypeId, entityId } =
            this.props;

        if (!spraySchemaEntityTypeId) {
            return null;
        }

        return (
            <EntityOptions
                entityTypeId={spraySchemaEntityTypeId}
                entityId={entityId}
            >
                {(options: EntityDropdownOptions): React.ReactElement => (
                    <SpraySchemaInnerEntityOptions
                        options={options}
                        sprayEntityId={entityId}
                    >
                        {(
                            innerEntityOptions: InnerEntityOptions
                        ): React.ReactElement => (
                            <Grid>
                                <Grid.Row>
                                    <Grid.Column>
                                        <SpraySchemaInnerEntityTableFieldRender
                                            name={name}
                                            validate={validate}
                                            entityTypeId={
                                                spraySchemaEntityTypeId
                                            }
                                            entityId={entityId}
                                            options={innerEntityOptions}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                                <SpraySchemaInnerEntityTableFieldWarning
                                    options={innerEntityOptions}
                                />
                            </Grid>
                        )}
                    </SpraySchemaInnerEntityOptions>
                )}
            </EntityOptions>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    spraySchemaEntityTypeId: selectSpraySchemaInnerEntityTypeId
});

export default connect(mapStateToProps)(SpraySchemaInnerEntityTableField);
